import { call, put } from 'redux-saga/effects';

import api from 'api';
import { IRotatedAuthTokensResponse } from 'api/components/Auth/types';
import BrowserStorage from 'api/utils/browserStorage';
import { getToken, setAccessRefreshTokens, setWellFunnelToken } from 'api/utils/tokenManagement';

import { notifyError } from 'store/notifications/actions';
import { handleAuthError } from 'store/subscriptions/sagas/utils';
import { getUserFeatures } from 'store/user/actions';

import { sendAnalyticNewTypeTokenUser, sendAnalyticOldTypeTokenUser } from 'services/Analytics';

import { authentication, setAuthenticationStatus, setAuthRedirectUrl } from '../actions';

import { getWFTokenForWebPlatform, waitForGetCurrentUser } from './helpers';

export function* authenticateSaga({ payload }: ReturnType<typeof authentication>) {
    const { onSuccess, onError, isOldTypeToken = false, isTokenFromUrl = false } = payload;

    try {
        if (isTokenFromUrl) {
            // Temporary solution, would be removed in the:
            // [YG-Chin-2881] Delete backdoor for exchanging an old token into access/refresh pair on WEB API
            // https://app.asana.com/1/1125283907112431/project/1207601892535016/task/1210057235241791?focus=true
            const oldTypeToken = getToken();

            if (isOldTypeToken && oldTypeToken) {
                yield call(setWellFunnelToken, oldTypeToken);
                yield call(sendAnalyticOldTypeTokenUser);
            } else {
                yield call(sendAnalyticNewTypeTokenUser);
            }

            // Clear browser storage on auth to prevent cross-user/stale data after token change
            BrowserStorage.clearExcept(['language']);

            try {
                const { access, refresh }: IRotatedAuthTokensResponse = yield call(api.auth.getMobileToken);

                yield call(setAccessRefreshTokens, { access, refresh });
            } catch (error: any) {
                const authErrorWasHandled = yield* handleAuthError(error);

                if (authErrorWasHandled) return;

                throw error;
            }
        }

        yield put(getUserFeatures());

        yield call(waitForGetCurrentUser);

        yield put(setAuthenticationStatus(true));

        if (onSuccess) yield call(onSuccess);

        yield put(setAuthRedirectUrl(null));

        // Temporary solution, would be removed in the:
        // [YG-Chin-2881] Delete backdoor for exchanging an old token into access/refresh pair on WEB API
        // https://app.asana.com/1/1125283907112431/project/1207601892535016/task/1210057235241791?focus=true
        if (isOldTypeToken) yield call(getWFTokenForWebPlatform);
    } catch (error: any) {
        yield put(notifyError({ message: 'message.error.somethingWentWrong' }));
        yield put(setAuthenticationStatus(false));

        if (onError) yield call(onError, error?.message);
    }
}
